import React from 'react';
import Modal from 'react-bootstrap-modal';
import TextInput from '../controls/textInput.jsx';
import TextAreaInput from '../controls/textAreaInput.jsx';
import InfoModal from './infoModal.jsx'
import { getCurrentUserId } from '../services/userRights';
import { apiPost } from '../services/apiClient';

export default class StatusSelectionModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
			isBusy: false,
			isAuthenticate: true,
			title: "Сообщение службе поддержки",
			login: "",
			email: "",
			question: "",
			errors: {},
            promiseResolve: null,
            promiseReject: null
        };

		this.infoModal = null;
    }

    open() {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
				isBusy: false,
				isAuthenticate: getCurrentUserId() !== undefined,
				login: "",
				email: "",
				question: "",
				errors: {},
                promiseResolve: resolve,
                promiseReject: reject
            });
        });
        return promise;
    }

    close(result) {
        if (result) {
            this.state.promiseResolve();
        } else {
            this.state.promiseReject();
        }
        this.setState({
            isOpen: false,
			isBusy: false,
            promiseResolve: null,
            promiseReject: null
        });
    }

	send() {
		let data = {
			login: this.state.login,
			email: this.state.email,
			question: this.state.question,
		};
		this.setState({ isBusy: true });
		apiPost('support/question', data)
			.then(() => {
				this.close(true);
				if (this.infoModal) {
					this.infoModal.open(this.state.title, "Ваше сообщение успешно отправлено");
				}
			})
			.catch(errors => {
				this.setState({ 
					isBusy: false,
					errors: errors.messages
				});
			});
	}

	renderUserName() {
		if (this.state.isAuthenticate) {
			return null;
		} else {
			return (
                <div className={"form-group" + (this.state.errors.login ? " has-error" : "")}>
                    <label htmlFor="modalUserName">Ваш логин<span className="text-red">*</span></label>
                    <TextInput id="modalUserName"
                        value={this.state.login}
						title={this.state.errors.login}
                        onChange={value => this.setState({ login: value })}
						disabled={this.state.isBusy}
                    />
                </div>
			);
		}
	}

	renderUserEmail() {
		if (this.state.isAuthenticate) {
			return null;
		} else {
			return (
                <div className={"form-group" + (this.state.errors.email ? " has-error" : "")}>
                    <label htmlFor="modalUserEmail">Контактный адрес электронной почты<span className="text-red">*</span></label>
                    <TextInput id="modalUserEmail"
                        value={this.state.email}
						title={this.state.errors.email}
                        onChange={value => this.setState({ email: value })}
						disabled={this.state.isBusy}
                    />
                </div>
			);
		}
	}

    render() {
        return (
			<div>
				<Modal show={this.state.isOpen} 
					onHide={() => this.close(false)} 
					aria-labelledby="ModalHeader" 
					backdrop="static"
				>
					<Modal.Header closeButton>
						<Modal.Title id='ModalHeader'>
							{this.state.title}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{this.renderUserName()}
						{this.renderUserEmail()}
						<div className={"form-group" + (this.state.errors.question ? " has-error" : "")}>
							<label htmlFor="modalQuestion">Ваше сообщение<span className="text-red">*</span></label>
							<TextAreaInput id="modalQuestion"
								value={this.state.question}
								title={this.state.errors.question}
								onChange={value => this.setState({ question: value })}
								disabled={this.state.isBusy}
							/>
						</div>
					</Modal.Body>
					<Modal.Footer>
                        <button className='btn btn-primary' onClick={() => this.send()} disabled={this.state.isBusy}>
							Отправить
						</button>
                        <Modal.Dismiss className='btn btn-default' disabled={this.state.isBusy}>
							Отмена
						</Modal.Dismiss>
					</Modal.Footer>
				</Modal>

				<InfoModal ref={modal => this.infoModal = modal} />
			</div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/modals/supportQuestionModal.jsx